// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1Zuk-","actionsCol":"EnrolledClinics_actionsCol__qWd4M"};